export default function checkroles(roles, msalRoles){
  if (msalRoles) {
    return msalRoles.some((r) => roles.indexOf(r) >= 0);
  }
  return false;
}